"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectPreferenceStatus = void 0;
function selectPreferenceStatus(preferences, preference) {
    var _a;
    return !!((_a = preferences === null || preferences === void 0 ? void 0 : preferences.activated) === null || _a === void 0 ? void 0 : _a.includes(preference));
}
exports.selectPreferenceStatus = selectPreferenceStatus;
